import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import footerLinks from "@/data/footerLinks"
import { SocialLinks } from "@/components/molecules/SocialLinks/SocialLinks"
import { getStorefront, siteName, type PageKey } from "@/lib/data/storefront"

export async function Footer() {
  const s = await getStorefront()
  // عنوان صفحة `/pages/…` من الإعدادات، فيتبع ما يُكتب في اللوحة
  const labelOf = (label: string, path: string) =>
    path.startsWith("/pages/") ? s.pages[path.slice(7) as PageKey]?.title || label : label

  return (
    <footer dir="rtl" className="bg-primary container" data-testid="footer">
      <div className="grid grid-cols-1 lg:grid-cols-3">
        <div className="p-6 border rounded-sm" data-testid="footer-customer-services">
          <h2 className="heading-sm text-primary mb-3 uppercase">
            خدمة الزبائن
          </h2>
          <nav className="space-y-3" aria-label="Customer services navigation">
            {footerLinks.customerServices.map(({ label, path }) => (
              <LocalizedClientLink
                key={label}
                href={path}
                className="block label-md"
                data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {labelOf(label, path)}
              </LocalizedClientLink>
            ))}
          </nav>
        </div>

        <div className="p-6 border rounded-sm" data-testid="footer-about">
          <h2 className="heading-sm text-primary mb-3 uppercase">عن المنصة</h2>
          <nav className="space-y-3" aria-label="About navigation">
            {footerLinks.about.map(({ label, path }) => (
              <LocalizedClientLink
                key={label}
                href={path}
                className="block label-md"
                data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {labelOf(label, path)}
              </LocalizedClientLink>
            ))}
          </nav>
        </div>

        <div className="p-6 border rounded-sm" data-testid="footer-connect">
          <h2 className="heading-sm text-primary mb-3 uppercase">تواصل معنا</h2>
          <SocialLinks contact={s.contact} />
          <div className="mt-3 space-y-1.5 label-md">
            {s.contact.phone && (
              <a href={`tel:${s.contact.phone.replace(/[^\d+]/g, "")}`} dir="ltr" className="block w-fit">
                {s.contact.phone}
              </a>
            )}
            {s.contact.email && (
              <a href={`mailto:${s.contact.email}`} dir="ltr" className="block w-fit">
                {s.contact.email}
              </a>
            )}
            {s.contact.address && <p>{s.contact.address}</p>}
            {s.contact.hours && <p className="text-secondary">{s.contact.hours}</p>}
          </div>
        </div>
      </div>

      <div className="py-6 border rounded-sm " data-testid="footer-copyright">
        <p className="text-md text-secondary text-center ">© {new Date().getFullYear()} {siteName(s)}</p>
      </div>
    </footer>
  )
}
